import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SortNumDescIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SortNumDesc",
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.05 23.74h-2.42V2.88c0-.48-.39-.88-.88-.88H9c-.48 0-.88.39-.88.88v20.87H5.7c-1.15 0-1.43.67-.61 1.48l4.79 4.78 4.79-4.79c.81-.81.53-1.47-.61-1.47Zm7.74-3.47-2.42 1.99-1.22-1.43 3.82-3.08h1.91V30h-2.09v-9.72Zm-1.11-6.03 3.07-4.38c-.18.08-.39.14-.6.17h-.01c-.2.03-.43.05-.66.05h-.02c-.53 0-1.03-.11-1.48-.31H21a3.8 3.8 0 0 1-1.22-.8 3.8 3.8 0 0 1-.81-1.19v-.02a3.7 3.7 0 0 1-.33-1.55v-.07c0-.61.13-1.18.35-1.7v.03c.2-.51.5-.95.86-1.32.39-.36.86-.64 1.38-.81h.03c.51-.21 1.11-.32 1.73-.32h.07c.61 0 1.19.12 1.73.33h-.03c.54.2 1 .5 1.39.87.76.72 1.23 1.74 1.23 2.87v.1c0 .63-.12 1.24-.34 1.8v-.03c-.12.35-.25.64-.39.91l.02-.04c-.15.28-.32.57-.52.88l-3.01 4.57h-2.47Zm4.62-8.2c0-.32-.06-.62-.16-.89v.02a2.25 2.25 0 0 0-1.17-1.27h-.01c-.24-.1-.52-.16-.81-.16h-.23c-.62 0-1.17.26-1.57.67-.39.43-.63 1-.63 1.63v.16c0 .32.06.63.16.91v-.02c.1.29.26.53.46.74.2.2.44.36.7.48h.01c.26.11.56.18.88.18.35-.01.67-.1.97-.23h-.02c.57-.21 1.01-.66 1.22-1.21.12-.3.19-.63.2-.97s0-.02 0-.02Z"
    })
  }));
};